import { render, staticRenderFns } from "./RdGroup.vue?vue&type=template&id=227a6388&scoped=true&"
import script from "./RdGroup.vue?vue&type=script&lang=js&"
export * from "./RdGroup.vue?vue&type=script&lang=js&"
import style0 from "./RdGroup.vue?vue&type=style&index=0&id=227a6388&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a6388",
  null
  
)

export default component.exports